import {InfoOutlined} from '@mui/icons-material'
import {Box, Stack, SxProps, Tooltip, Typography} from '@mui/material'

export const HeaderWithTooltip = ({
  headerText,
  tooltipText,
  sx,
  size = 'default'
}: {
  headerText: string
  tooltipText: string
  sx?: SxProps
  size?: 'small' | 'default'
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: size === 'small' ? 'row-reverse' : 'row',
      ...sx
    }}
  >
    <Typography variant={'caption'}>{headerText}</Typography>
    <Tooltip
      title={
        <Stack spacing={1}>
          <Typography fontWeight="bold">{headerText}</Typography>
          <Typography>{tooltipText}</Typography>
        </Stack>
      }
    >
      <Typography
        variant={size === 'small' ? 'caption' : 'body1'}
        fontWeight={size === 'small' ? 'regular' : 'bold'}
        display={'flex'}
        alignItems={'center'}
      >
        <InfoOutlined sx={size === 'small' ? {mr: 0.5, fontSize: 16} : {ml: 1}} />
      </Typography>
    </Tooltip>
  </Box>
)
